<template>
  <hr
    class="own-rule"
    :class="[
      `own-rule--${type}`,
      !vertical && 'own-rule--horizontal',
      vertical && 'own-rule--vertical',
    ]"
  />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    type?: 'solid' | 'dashed'
    vertical?: boolean
  }>(),
  {
    type: 'solid',
    vertical: false,
  }
)
</script>

<style lang="scss">
.own-rule {
  &--horizontal {
    height: 0;
    width: 100%;
    border: transparent;
    border-top: 1px solid var(--divider);
  }

  &--vertical {
    width: 0;
    border: none;
    border: transparent;
    border-left: 1px solid var(--divider);
  }

  &--dashed {
    border-style: dashed;
  }
}
</style>
